var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTracker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 36 39",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n        stroke: #000;\n        stroke-miterlimit: 10;\n        stroke-width: 2px;\n      }\n\n      .cls-2 {\n        fill: #000;\n        stroke-width: 0px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_3",
    "data-name": "Layer 3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M4.28,1h27.44c1.81,0,3.28,1.21,3.28,2.7v25.3H1V3.7c0-1.49,1.47-2.7,3.28-2.7Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 6,
    y: 31.5,
    width: 24,
    height: 2,
    rx: 0.5,
    ry: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M19.06,28.75H2.95c-1.08,0-1.95.81-1.95,1.8v2.36c0,1.71,1.28,3.09,2.87,3.09h28.27c1.58,0,2.87-1.38,2.87-3.09v-4.16h-15.94Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "8 33.5 8 39 10.59 37.1 13 39 13 33.5 8 33.5"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 17.5,
    cy: 16.5,
    r: 5.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M13.03,14.11s-2.47-1.87-.79-3.55,3.36.89,3.36.89"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M20.48,11.77s1.55-2.21,3.06-.8-.67,2.95-.67,2.95"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTracker);
export default __webpack_public_path__ + "static/media/Tracker.6ce1c966cc730052af14a9f4824702bf.svg";
export { ForwardRef as ReactComponent };